// apps/einstein/src/providers/index.ts
import { ProviderConfig } from "./types";
import { defaultConfig } from "./configs/default.config";
import { samcartConfig } from "./configs/samcart.config";

const providerConfigs: Record<string, ProviderConfig> = {
  samcart: samcartConfig,
};

export const getProviderConfig = (
  provider: string | null | undefined
): ProviderConfig => {
  const key = provider?.toLowerCase();
  return key ? providerConfigs[key] ?? defaultConfig : defaultConfig;
};

export { defaultConfig } from "./configs/default.config";
export { samcartConfig } from "./configs/samcart.config";
export * from "./types";
export * from "./utils";
